import React from "react";
import Box from "@mui/material/Box";
import CompanyCard from "../cardComponent/CompanyCard";
const imageUrl = `${process.env.PUBLIC_URL}/Documents/ignosilogo.png`;

function HomeCenWork() {
  return (
    <Box sx={{ padding: "20px", width: "100%", display: "flex", justifyContent: "center" }}>
      <Box sx={{ width: { xs: "90vw", sm: "70vw", md: "50vw" } }}>
        <CompanyCard 
          img={imageUrl} 
          sub={'2024-2025'} 
          title={'Ignosi Enterprises'} 
          des={"Ignosi is Kerala's top financial software company, specializing in banking software and chitty management systems using PHP and Java."} 
        />
      </Box>
    </Box>
  );
}

export default HomeCenWork;
